import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import { isEmpty } from '../Core/SmartFunctions';

const ExportToExcelCommon = (rawData:any,fileName:any, entity:any = "Excel") => {
    if (!rawData || !rawData.length) {
        toast.error('No data to export!');
        return;
    }

    // Get all keys from first row as headers
    const columnHeaders = Object.keys(rawData[0]);

    // Format data: stringify arrays/objects for readable Excel
    const gridData = rawData.map((row:any) => {
        const formattedRow: { [key: string]: any } = {}; 
        columnHeaders.forEach(key => {
            const val = row[key];
            if (Array.isArray(val) || (typeof val === 'object' && val !== null)) {
                formattedRow[key] = JSON.stringify(val, null, 2); // readable format
            } else {
                formattedRow[key] = val ?? ''; // handle null/undefined
            }
        });
        return formattedRow;
    });

    // Create worksheet without headers
    const worksheet = XLSX.utils.json_to_sheet([], { skipHeader: true });

    // Add custom headers in first row
    XLSX.utils.sheet_add_aoa(worksheet, [columnHeaders]);

    // Add formatted data starting from second row
    XLSX.utils.sheet_add_json(worksheet, gridData, { origin: 'A2', skipHeader: true });

    // Create workbook and append worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Customize file name
    let downloadFileName = fileName;
    // Export Excel directly (frontend)
    XLSX.writeFile(workbook, `${downloadFileName}.xlsx`);

    let toastMessage = `${entity} exported successfully!`;
    // toast.success('Excel exported successfully!');
    toast.success(`${toastMessage}`);
};

export default ExportToExcelCommon;
